import * as React from 'react';
import { SpinnerTypes, } from './types';
import { st, classes } from './Spinner.deprecated.st.css';
export class Spinner extends React.Component {
    render() {
        const { className, type, diameter, isCentered, isStatic, 'aria-label': ariaLabel, } = this.props;
        return (React.createElement("svg", { viewBox: "0 0 50 50", "aria-label": ariaLabel, className: st(classes.root, {
                centered: !!isCentered,
                static: !!isStatic,
                slim: type !== SpinnerTypes.regular,
            }, className), style: diameter
                ? {
                    width: `${diameter}px`,
                    height: `${diameter}px`,
                    top: isCentered ? `calc(50% - ${diameter / 2}px)` : 'auto',
                    left: isCentered ? `calc(50% - ${diameter / 2}px)` : 'auto',
                }
                : {}, "data-hook": this.props['data-hook'] },
            React.createElement("circle", { cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: type === SpinnerTypes.regular ? 4 : 1, className: classes.circle })));
    }
}
Spinner.displayName = 'Spinner';
Spinner.defaultProps = {
    type: SpinnerTypes.regular,
    isCentered: false,
    isStatic: false,
};
//# sourceMappingURL=Spinner.js.map